import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }

import { reactive, onMounted } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  __name: 'Setting',
  setup(__props) {

const form = reactive({
  title: '',
  wln_appkey: '',
  wln_secret: '',
  appid: '',
  appsecret: '',
})
const getInit = () => {
  const loading = ElLoading.service({lock: true})
  api.accessoryApi.getInit().then((res:any)=>{
    if(res.code==200){
      form.title = res.data.title
      form.wln_appkey = res.data.wln_appkey
      form.wln_secret = res.data.wln_secret
      form.appid = res.data.appid
      form.appsecret = res.data.appsecret
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
const onSubmit = () => {
  const loading = ElLoading.service({lock: true})
  api.accessoryApi.setInit(form).then((res:any)=>{
    if(res.code==200){
      ElMessage({
        message: res.message,
        type: 'success',
      })
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
onMounted(() => {
  getInit()
})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _createTextVNode("工作台")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/website/setting' } }, {
              default: _withCtx(() => [
                _createTextVNode("网站管理")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("网站配置")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "180px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "AppID(小程序ID)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.appid,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.appid) = $event)),
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "AppSecret(小程序密钥)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.appsecret,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.appsecret) = $event)),
                  placeholder: "无需更改，请勿填写",
                  maxlength: "80",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})